enum ReportStatus {
  /** Новый */
  New = 'new',

  /** В процессе */
  InProgress = 'inProgress',

  /** Завершено */
  Done = 'done',

  /** Ошибка */
  Error = 'error',
}

export default ReportStatus
